import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './ButtonBar.css';
import Image from '../../src/Components/images/logo.webp';
// import notepadIcon from '../images/notepadIcon.svg';
import notepad from '../images/notepad.png';
import toast from "react-hot-toast";
import axios from "axios";

import imageCompression from "browser-image-compression";
import { language_selected } from "./language";


//import hdfclogo from '../Components/images/app_logo.png';
// import hdfc from '../Components/images/app_logo.png'

function ButtonBar({language_text}) {
  const allowedImageTypes = ["image/jpeg", "image/png", "image/gif", "image/bmp"];

  const navigate = useNavigate();
  const location = useLocation();
  const desktopCenterRef = useRef(null); // Ref to the desktopCenter div
  const [activeButton, setActiveButton] = useState("Draw"); // Set "Draw" as the default active button
  // const [language_text, setLanguage_text] = useState("header_text");
  // useEffect(() => {
  //   const language = new URLSearchParams(window.location.search).get("language_selected") || "english";
  //   console.log('language_selected', language);
  //   console.log(language_selected[language].header_text);
  //   setLanguage_text(language);
  // }, [])

  const fileInputRef = useRef(null);

  const [cardData, setCardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [img, setImg] = useState({});
  const [isImageSelected, setIsImageSelected] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);
  const [showRemark, setShowRemark] = useState(false);
  const [ipAddress, setIpAddress] = useState();


  // Function to handle button clicks and set the active button
  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const [showDesktopCenter, setShowDesktopCenter] = useState(false);

  const navigateToSignSdk = () => {
    navigate("/SignSdk");
  };

  const navigateToCapture = () => {
    navigate("/Capture");
  };

  const navigateToGallery = async (e) => {
    const hasSelectedImage = e.target.files && e.target.files.length > 0;
    setSelectedImage(hasSelectedImage ? e.target.files[0] : null);
    const isImage = hasSelectedImage && allowedImageTypes.includes(e.target.files[0].type);

    setIsImageSelected(isImage);
    setShowDesktopCenter(false);

    if (!isImage) {
      toast.error("Please select a valid image (JPEG, PNG, GIF, or BMP).");
    } else {
      // Compress and send the image to the API as soon as the image is selected
      try {
        const compressedImage = await compressImage(e.target.files[0]);
        const formData = new FormData();
        formData.append("image", compressedImage);
        setImg(formData);
        await sendImageToAPI(formData);
      } catch (error) {
        toast.error("Image compression failed.");
      }
    }
  };

  // Compress image function
  const compressImage = async (imageFile) => {
    const options = {
      maxSizeMB: 4, // Maximum size in MB
      maxWidthOrHeight: 1920, // Maximum width or height
      useWebWorker: true, // Use web worker for faster compression
    };

    try {
      const compressedFile = await imageCompression(imageFile, options);
      return compressedFile;
    } catch (error) {
      console.error("Image compression error:", error);
      throw error;
    }
  };

  // Reset canvas function
  const resetCanvas = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setSelectedImage(null);
    setIsImageSelected(false);
    setCroppedImage(null);
    if (!isImageSelected) {
      setShowDesktopCenter(false);
    }
  };

  // Send image to API function
  const sendImageToAPI = async (formData) => {

    setLoading(false);
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        const formData = new FormData();
        const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
        formData.append("image", "b'" + base64String);
        const config = {
          method: "post",
          url: `https://.execute-api.ap-south-1.amazonaws.com/default/signaturevalidate?Isdigital=0&IsSdk=1`,
          headers: {
            "x-api-key": "",
            "authorizationToken": ""
          },
          data: formData,
        };
        axios(config)
          .then(function (response) {
            setCardData(response.data);
            setLoading(true);
            setShowRemark(true);

            if (response.data.status !== 1) {
              // toast.error(response.data.remark);
              showPopupMessage(response.data.remark); // Show error message

            }

            setTimeout(() => {
              setShowRemark(false);
              if (response.data.status === 1) {
                showPopupMessage("Valid Sign"); // Show error message

                // toast.success("Valid Sign");  

                const message = {
                  accessRequestId: response.data.accessRequestId,
                  signature_status: response.data.signature_status,
                  ipAddress: ipAddress,
                };
                window.parent.postMessage(message, "*");
              }
            }, 2000);
          })
          .catch((error) => {
            setLoading(true);
            toast.error("Something went wrong with the server");
          });
      };
      reader.readAsDataURL(formData.get("image"));
    } catch (error) {
      setLoading(true);
      // toast.error("Something went wrong with the server");
      showPopupMessage(language_selected[language_text].valid_image_required, "error");
// Show error message
    }
  };


  const toggleDesktopCenter = () => {
    setShowDesktopCenter((prevState) => !prevState);
  };

  const handleAttachGalleryClick = () => {
    if (!showDesktopCenter) {
      fileInputRef.current.click();
    } else {
      toggleDesktopCenter();
    }
  };

  const handleGalleryButtonClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        desktopCenterRef.current &&
        !desktopCenterRef.current.contains(event.target)
      ) {
        setShowDesktopCenter(false);
        fileInputRef.current = document.getElementById("fileInput");

      }
    };

    // Update the activeButton state based on the current location
    if (location.pathname === "/") {
      setActiveButton("Draw");
    } else if (location.pathname === "/Capture") {
      setActiveButton("Upload");
    } else if (location.pathname === "/Gallery") {
      setActiveButton("Upload");
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [location]);



  const onChange = async (e) => {
    const hasSelectedImage = e.target.files && e.target.files.length > 0;
    setSelectedImage(hasSelectedImage ? e.target.files[0] : null);
    const isImage = hasSelectedImage && allowedImageTypes.includes(e.target.files[0].type);

    setIsImageSelected(isImage);
    setShowDesktopCenter(false);

    if (!isImage) {
      // toast.error("Please select a valid image (JPEG, PNG, GIF, or BMP).");
          showPopupMessage(language_selected[language_text].valid_image_required, "error"); // Show error message


    } else {
      // Compress and send the image to the API as soon as the image is selected
      try {
        const compressedImage = await compressImage(e.target.files[0]);
        const formData = new FormData();
        formData.append("image", compressedImage);
        setImg(formData);
        await sendImageToAPI(formData);
      } catch (error) {
        // toast.error("Image compression failed.");
        showPopupMessage("Image compression failed"); // Show error message

      }
    }
  };

  const showPopupMessage = (message, type) => {
    const popup = document.getElementById("popupmessage");
    popup.innerHTML = message;
    const popupmessagesuccess = document.getElementById("popupmessagesuccess");
    popupmessagesuccess.innerHTML = message;

    popup.style.display = "block";
    popup.style.backgroundColor = type === "success" ? "green" : "red";


    // setTimeout(() => {
    //   popup.style.display = "none";
    // }, 3000); // Hide after 3 seconds
  };


  //   setLoading(false);
  //   try {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       const formData = new FormData();
  //       const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
  //       formData.append("image", "b'" + base64String);
  //       const config = {
  //         method: "post",
  //         url: `https://.execute-api.ap-south-1.amazonaws.com/default/signaturevalidate?Isdigital=0&IsSdk=1`,
  //         headers: {
  //           "x-api-key": "",
  //           "authorizationToken": ""
  //         },
  //         data: formData,
  //       };
  //       axios(config)
  //         .then(function (response) {
  //           setCardData(response.data);
  //           setLoading(true);
  //           setShowRemark(true);

  //           if (response.data.status !== 1) {
  //             toast.error(response.data.remark);
  //           }

  //           setTimeout(() => {
  //             setShowRemark(false);
  //             if (response.data.status === 1) {
  //               toast.success("Valid Sign");  
  //               setTimeout(() => {
  //                 const message = {
  //                   accessRequestId: response.data.accessRequestId,
  //                   signature_status: response.data.signature_status,
  //                   ipAddress: ipAddress,
  //                 };
  //                 console.log("THIS IS POSTMESSAGE", message);
  //                 window.parent.postMessage(message, "*");
  //               }, 1000);
  //             } 
  //           }, 2000);
  //         })
  //         .catch((error) => {
  //           setLoading(true);
  //           toast.error("Something went wrong with the server");
  //         });
  //     };
  //     reader.readAsDataURL(formData.get("image"));
  //   } catch (error) {
  //     setLoading(true);
  //     toast.error("Something went wrong with the server");
  //   }
  // };

  return (

    <div>
      <div className="topContailModal mob-text-center">

        <div className="leftContain">
          <img src={notepad} width="30" height="auto" />
        </div>
        <div className="rightContain">
          <span className="heading">{language_selected[language_text]?.header_text}</span>
        </div>
        <div id="popupmessage" className="errorWindow" style={{ display: "none" }}></div>
        <div id="popupmessagesuccess" className="successWindow" style={{ display: "none" }}></div>
      </div>


      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px",
          justifyContent: "center",
          display: "none",
        }}
      >
        <button className="hide-on-desktop"
          onClick={() => {
            handleButtonClick("Draw");
            navigateToSignSdk();
          }}
          style={{
            marginRight: "10px",
            padding: "6px 20px",
            fontSize: "16px",
            // background: activeButton === "Draw" ? "#FF7518" : "",
            background: activeButton === "Draw" ? "#58a4b0" : "",
            color: activeButton === "Draw" ? "#fff" : "#222",
            // borderBottom: activeButton === "Draw" ? "2px solid #228B22" : "none",
            borderRadius: "8px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-pencil-line"
          >
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
            <path d="m15 5 3 3" />
          </svg>
          &nbsp;Draw
        </button>
        <button
          onClick={() => {
            // handleButtonClick("Upload");
            navigateToGallery();
            // toggleDesktopCenter();
          }}
          style={{
            marginRight: "10px",
            padding: "6px 20px",
            fontSize: "16px",
            borderRadius: "8px",
            background: activeButton === "Upload" ? "#0085ff" : "",
            color: activeButton === "Draw" ? "#222" : "#fff",
            // borderBottom: activeButton === "Upload" ? "2px solid #228B22" : "none",
          }}
          className="btn"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-folder-up"
          >
            <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
            <path d="M12 10v6" />
            <path d="m9 13 3-3 3 3" />
          </svg>
          &nbsp;Upload
        </button>
        <div className="uploadTextHeading">Upload Signature on plain paper</div>
        <div>
          <button ref={fileInputRef}
            onClick={navigateToGallery} className="uploadBtn">
            <input
              type="file"
              id="fileInput"
              ref={fileInputRef}
              onChange={onChange}
              accept="image/*"
              style={{ display: "none" }}
            /></button>
        </div>
      </div>



      {showDesktopCenter && (
        <div
          ref={desktopCenterRef}
          style={{
            opacity: 1,
            transition: "opacity 0.3s ease-in-out",
            background: "rgba(0,0,0,0.3",
            position: "fixed",
            top: "0",
            left: "0",
            zIndex: "9999998",
            width: "100%",
            height: "100%",
          }}
        >
          <div
            className="desktopCenter"
            style={{
              opacity: 1,
              transition: "opacity 0.3s ease-in-out",
              background: "#fff",
              maxWidth: "650px",
              width: "100%",
              borderRadius: "15px",
              position: "fixed",
              bottom: "0",
              padding: "20px",
              zIndex: "9999998",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                cursor: "pointer",
                marginBottom: "20px",
              }}
              onClick={toggleDesktopCenter}
            >
              {/* Close button SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </div>
            <h2 style={{ fontSize: "24px" }}>Attach Signature</h2>


            <button
              className="btn"
              onClick={navigateToGallery}

              onMouseEnter={(e) => {
                e.target.style.background = "rgb(33, 150, 243)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background =
                  location.pathname === "/Gallery" ? "#007bff" : "#ccc";
              }}
            >

              Gallery
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ButtonBar;
